module.exports = {"511527100":"筠连镇","511527101":"腾达镇","511527102":"巡司镇","511527103":"双腾镇","511527104":"沐爱镇","511527105":"维新镇","511527107":"镇舟镇","511527108":"蒿坝镇","511527109":"大雪山镇","511527200":"武德乡","511527202":"塘坝乡","511527203":"龙镇乡","511527204":"孔雀乡","511527205":"乐义乡","511527206":"高坎乡","511527208":"团林苗族乡","511527209":"联合苗族乡","511527210":"高坪苗族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511527.json
// module id = 2179
// module chunks = 0